import type { IntegrationLogFilterValues } from "../types/integration-logs.types";

/**
 * Single source of truth for the integration-log query string. Both the
 * pagination links and the filter modal build their target URL through here so
 * paging never silently drops an active filter.
 */
export function buildIntegrationLogQuery(params: {
  limit: number;
  offset: number;
  filters: IntegrationLogFilterValues;
}): string {
  const query = new URLSearchParams();
  query.set("limit", String(params.limit));
  query.set("offset", String(params.offset));

  const { filters } = params;
  if (filters.search) {
    query.set("search", filters.search);
  }
  if (filters.storeId) {
    query.set("storeId", filters.storeId);
  }
  if (filters.status) {
    query.set("status", filters.status);
  }
  if (filters.direction) {
    query.set("direction", filters.direction);
  }
  if (filters.provider) {
    query.set("provider", filters.provider);
  }
  if (filters.dateFrom) {
    query.set("dateFrom", filters.dateFrom);
  }
  if (filters.dateTo) {
    query.set("dateTo", filters.dateTo);
  }

  return query.toString();
}

export function countActiveIntegrationLogFilters(
  filters: IntegrationLogFilterValues,
): number {
  return [
    filters.search,
    filters.storeId,
    filters.status,
    filters.direction,
    filters.provider,
    filters.dateFrom,
    filters.dateTo,
  ].filter((value) => Boolean(value && value.trim())).length;
}
